import Vue from 'vue';
import Vuex from 'vuex';
import { appStore } from './modules/App/app';
import { authStore } from './modules/Auth/auth'
import { companyStore } from './modules/Company/company';
import { notificationsStore } from './modules/Notifications/notifications';
import { installationsStore } from './modules/Installations/installations';
import { parametersStore } from './modules/Parameters/parameters';
import { pvsystStore } from './modules/Pvsyst/pvsyst';

Vue.use(Vuex);

import createPersistedState from "vuex-persistedstate";

const store = new Vuex.Store({
  modules: {
    appStore,
    authStore,
    companyStore,
    notificationsStore,
    installationsStore,
    parametersStore,
    pvsystStore
  },
  strict: false,
  plugins: [createPersistedState()],
});

export default store;
